/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Condition } from './condition';
import { InsurancePeriod } from './insurancePeriod';
import { PaymentContributor } from './paymentContributor';
import { Price } from './price';
import { PaymentFrequency } from './paymentFrequency';
import { PaymentMethod } from './paymentMethod';

/**
 * Abstract base class for all products at level two. Middle level in product hierarchy.  Defines a product for a concrete insurance sector.   (bipro-produktmodell::Produkt)
 */
export interface ProductBase {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  paymentMethod?: PaymentMethod;
  paymentFrequency?: PaymentFrequency;
  paymentContributor?: PaymentContributor;
  insurancePeriod?: InsurancePeriod;
  /**
   * Price affecting conditions, e.g. an incentive code.   (bipro-produktmodell::Kondition)
   */
  conditions?: Array<Condition>;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
}
export namespace ProductBase {}
